module.exports = __webpack_public_path__ + "static/media/fissura.5791662c.jpg";